/* --------------------------------------------------------------------------------------
   appSettings.const.js
   Copyright © 2018 Xerox Corporation. All Rights Reserved. 
   
   Copyright protection claimed includes all forms and matters of copyrightable material 
   and information now allowed by statutory or judicial law or hereinafter granted, 
   including without limitation, material generated from the software programs which 
   are displayed on the screen such as icons, screen display looks, etc.
   -------------------------------------------------------------------------------------
*/

var host = window.location.host
//console.log(host)
var api = "https://api.xeroxtestgrading.com/api"

if (host.indexOf("app.xeroxtestgrading.com") > -1) {
  api = "https://api.xeroxtestgrading.com/api"
} else if (host.indexOf("-test") > -1) {
  api = "https://xeroxtestgradingapi-test.azurewebsites.net/api"
} else if (host.indexOf("-staging") > -1) {
  api = "https://xeroxtestgradingapi-staging.azurewebsites.net/api"
}

export const appSettings  = {
  deviceUrl: "http://127.0.0.1",
  apiUrl: api,
  version: "0.0.1"
}



// WEBPACK FOOTER //
// ./src/app/constants/appSettings.const.js